import Home from '../views/Home.vue'
export default {
  path: '/construction',
  name: '建设指南',
  component: Home,
  iconCls: 'el-icon-user-solid',
  roles: ['AppUser'],
  hidden: true,
  children: [
    {
      path: '/construction',
      component: () =>
                import('../views/construction/index'),
      name: '建设指南',
      roles: ['AppUser'],
      hidden: true
    }
  ]
}
